import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import ViewData from "./ViewData";
import { WarehouseListContainer } from "./WarehouseList.styled";
import AddEditWarehouse from "../AddEditWarehouse/AddEditWarehouse";
import "./WarehouseList.scss";
import UserInfo from "@utils/UserInfo";
/**
 * WarehouseList List,
 * Path - /companies/{companyId}/hauliers/{haulierId}/warehouses
 * @see See [CenterProducts Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2944892929/Company+view+page+-+Warehouses)
 * @component
 */
const WarehouseList = (props) => {
  const { t, carrierId, companyId, companyStatus, companyName, countryId } =
    props;

  const [isAddWarehousePopupVisible, setAddWarehousePopupVisible] =
    useState(false);

  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  const createWarehouse = () => {
    setAddWarehousePopupVisible(true);
  };

  const closeWarehousePopupVisible = () => {
    setAddWarehousePopupVisible(false);
  };

  return (
    <WarehouseListContainer className="center-products-list">
      <ViewData
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        carrierId={carrierId}
        companyId={companyId}
        countryId={countryId}
        companyStatus={companyStatus}
        createWarehouse={createWarehouse}
      />
      {isAddWarehousePopupVisible && (
        <AddEditWarehouse
          carrierId={carrierId}
          companyId={companyId}
          countryId={countryId}
          onClose={closeWarehousePopupVisible}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </WarehouseListContainer>
  );
};

WarehouseList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(WarehouseList);
